// export const BASE_URL = "https://test.ssdneducation.com/";
export const BASE_URL = "https://mylearn.ssdntech.com/";
// export const BASE_URL = "http://127.0.0.1:8000/";
export const EMAIL_SERVICE_ID = "service_nh989do";
export const EMAIL_TEMPLATE_ID = "template_aoc6thy";
export const EMAIL_PUBLIC_KEY = "dbLjWUkuD_YHg9BuM";
export const MS_CLIENT_ID = "a3a3ebe0-05a7-4064-91c3-027597e10bd7";
export const MS_AUTHORITY_URL = "https://login.microsoftonline.com/c0807f6d-1970-4774-af4b-ccd5740e312b";
// export const MS_REDIRECT_URI = "https://test.ssdneducation.com/dashboard";
export const MS_REDIRECT_URI = "https://mylearn.ssdntech.com/dashboard";
export const MS_REDIRECT_URI_LOCAL = "http://localhost:3000/dashboard";